import { styled } from '@mui/material';
import { Link } from 'react-router';

import { BackArrowIcon } from '@app-velocity/icons';

import { TeamsRoutesPaths } from '../../../../paths/TeamsRoutesPaths';
import { useTeamAdminContext } from '../../../../context/useTeamAdminContext';

const StyledBackLink = styled(Link)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 700,
  '&:link,&:visited,&:hover,&:active': {
    color: 'var(--text-text-primary-color)',
  },
  svg: {
    flex: '0 0 auto',
    fill: 'var(--button-primary-icon-icon-color)',
  },
}));

const BackLinkText = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const BackLink = () => {
  const { team, workspaceId } = useTeamAdminContext();

  return (
    <StyledBackLink
      to={TeamsRoutesPaths.workspaceMain(team.id || '', workspaceId)}
    >
      <BackArrowIcon /> <BackLinkText>{team.name}</BackLinkText>
    </StyledBackLink>
  );
};
